import { Link } from '@material-ui/core';
import React from 'react';

import { PlexIconButton, Props as PlexIconButtonProps } from './PlexIconButton';

interface Props extends Omit<PlexIconButtonProps, 'onClick'> {
  href: string;
}

export const PlexIconButtonHref = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLAnchorElement>): React.ReactElement => {
    const { href, ...iconButtonProps } = props;
    const content = <PlexIconButton {...iconButtonProps} onClick={undefined} />;
    return props.disabled ? (
      content
    ) : (
      <Link href={href} tabIndex={-1} underline={'none'} target="_blank" rel="noopener noreferrer">
        {content}
      </Link>
    );
  }
);
